import { api } from "@/api";
import { TicketType } from "@/api/tickets/tickets";

import {
  setTicketCategories,
  setLocations,
  setOffices,
  setRenters,
  setUsers,
  setRequisites,
} from "@/app/store/handbooks/reducer";
import { setChangeLogRecords } from "@/app/store/user/reducer";

type HandbookMapEntry = {
  apiCall: (args?: any) => Promise<any>;
  action: (data: any) => any;
};

export type Handbook =
  | "ticketCategories"
  | "locations"
  | "offices"
  | "renters"
  | "users"
  | "requisites"
  | "changeLogs";

export const handbookMap: Record<Handbook, HandbookMapEntry> = {
  ticketCategories: {
    apiCall: () => {
      return new Promise((resolve, reject) => {
        const types = ["user_to_landlord", "to_platform"];
        const promises = types.map((type) =>
          api.tickets.categories.list(type as TicketType),
        );
        Promise.all(promises)
          .then((data) => resolve({ data: data.flatMap((el) => el.data) }))
          .catch(reject);
      });
    },
    action: setTicketCategories,
  },
  locations: {
    apiCall: () => api.locations.list(),
    action: setLocations,
  },
  renters: {
    apiCall: () => api.renters.list(),
    action: setRenters,
  },
  users: {
    apiCall: () => api.renters.listEmployees(),
    action: setUsers,
  },
  offices: {
    apiCall: () => api.officies.list(),
    action: setOffices,
  },
  requisites: {
    apiCall: () => api.requisites.list(),
    action: setRequisites,
  },
  changeLogs: {
    apiCall: () => api.changeLogs.get(),
    action: setChangeLogRecords,
  },
};
